module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "group-details"
    }
  }, [(_vm.fetchedInitialGroupDetails && !_vm.leaveGroupMode) ? [(!_vm.changeGroupNameMode) ? [_c('div', {
    key: "group-details",
    staticClass: "group-details"
  }, [_c('h1', [(_vm.groupDetails.isPublic) ? _c('span', [_vm._v("Public")]) : _vm._e(), _vm._v(" Group: " + _vm._s(_vm.groupDetails.name))]), _vm._v(" "), (_vm.moderatorStatus === 'owner') ? _c('a', {
    attrs: {
      "href": "#change-group-name"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeGroupNameMode = true;
      }
    }
  }, [_vm._v("Change Group Name")]) : _vm._e(), _vm._v(" "), (_vm.moderatorStatus === 'owner' && !_vm.groupDetails.isPublic) ? _c('a', {
    attrs: {
      "href": "#make-public"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePublicStatus(true)
      }
    }
  }, [_vm._v("Make Group Public")]) : _vm._e(), _vm._v(" "), (_vm.moderatorStatus === 'owner' && _vm.groupDetails.isPublic) ? _c('a', {
    attrs: {
      "href": "#make-private"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePublicStatus(false)
      }
    }
  }, [_vm._v("Make Group Private")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#leave-group"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveGroupMode = true;
      }
    }
  }, [_vm._v("Leave Group")])])] : _vm._e(), _vm._v(" "), (_vm.changeGroupNameMode) ? [_c('div', {
    key: "group-update-name",
    staticClass: "group-update-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroupName),
      expression: "newGroupName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Group name...",
      "disabled": _vm.savingNewGroupName
    },
    domProps: {
      "value": (_vm.newGroupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGroupName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.savingNewGroupName
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeGroupNameMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingNewGroupName
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateGroupName($event)
      }
    }
  }, [_vm._v("Submit")])])])] : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("\n            Members\n            "), (!_vm.inviteMemberMode) ? _c('a', {
    attrs: {
      "href": "#invite-member"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.inviteMemberMode = true
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.inviteMemberMode) ? _c('a', {
    attrs: {
      "href": "#return-from-invite-member"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.inviteMemberMode = false
      }
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), (!_vm.inviteMemberMode) ? _c('section', {
    attrs: {
      "id": "members"
    }
  }, [_c('ul', _vm._l((_vm.groupDetails.members), function(user) {
    return _c('li', {
      key: user.id
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), (user.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))]), _vm._v(" "), (user.moderatorStatus === 'owner') ? _c('i', {
      staticClass: "fa fa-star mod-status status-owner"
    }) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator') ? _c('i', {
      staticClass: "fa fa-star mod-status status-moderator"
    }) : _vm._e()]), _vm._v(" "), (_vm.moderatorStatus === 'owner' || _vm.moderatorStatus === 'moderator') ? _c('span', {
      staticClass: "moderator-controls"
    }, [(user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator') ? _c('a', {
      attrs: {
        "href": "#promote-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.promote(user)
        }
      }
    }, [_vm._v("Promote")]) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator' && user.id !== _vm.ownId) ? _c('a', {
      attrs: {
        "href": "#demote-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.demote(user)
        }
      }
    }, [_vm._v("Demote")]) : _vm._e(), _vm._v(" "), (user.moderatorStatus !== 'owner' && user.moderatorStatus !== 'moderator') ? _c('a', {
      attrs: {
        "href": "#kick-member"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.kick(user)
        }
      }
    }, [_vm._v("Kick")]) : _vm._e()]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.inviteMemberMode) ? _c('section', {
    attrs: {
      "id": "add-member"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteMemberValue),
      expression: "inviteMemberValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search for a user..."
    },
    domProps: {
      "value": (_vm.inviteMemberValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteMemberValue = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inviteMemberValue.length > 0 && _vm.filteredInviteMembersList.length === 0) ? _c('h1', [_vm._v("No Matching Members Found")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredInviteMembersList), function(user) {
    return _c('li', {
      key: user.id
    }, [_c('a', {
      staticClass: "add-member-button",
      attrs: {
        "href": "#add"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addMember(user)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), (user.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))]), _vm._v(" "), (user.moderatorStatus === 'owner') ? _c('i', {
      staticClass: "fa fa-star mod-status status-owner"
    }) : _vm._e(), _vm._v(" "), (user.moderatorStatus === 'moderator') ? _c('i', {
      staticClass: "fa fa-star mod-status status-moderator"
    }) : _vm._e()])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.leaveGroupMode) ? [_c('div', {
    staticClass: "leave-group"
  }, [_c('h1', [_vm._v("Really leave this group?")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveGroupMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.leaveGroup($event)
      }
    }
  }, [_vm._v("Leave")])]), _vm._v(" "), (_vm.moderatorStatus === 'owner' && _vm.groupDetails.members.length > 1) ? [_c('h1', [_vm._v("New Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOwner),
      expression: "newOwner"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newOwner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.groupDetails.members), function(user) {
    return (user.id !== _vm.ownId) ? _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.alias))]) : _vm._e()
  }), 0)] : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus-circle add-member"
  }), _vm._v(" Invite")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chevron-circle-left add-member"
  }), _vm._v(" Return")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4565c261"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ChatSidePanelWidgets/GroupDetails.vue
// module id = 399
// module chunks = 1